module.exports = "<div class=component-calendar-workflow> <div class=workflow-schedule id=workflow-{{table_id}}></div> <div class=workflow-content> <span class=workflow-content-title>{{name}}</span> </div> </div>";


//////////////////
// WEBPACK FOOTER
// ./app/components/calendar/right-content/right.content.workflowcontent/right.content.workflowcontent.html
// module id = 4898
// module chunks = 50